// extracted by mini-css-extract-plugin
export default {"loginContainer":"styles_loginContainer__I-v4I","wrapper":"styles_wrapper__YiFrr","header":"styles_header__rir62","image":"styles_image__SMh3U","img":"styles_img__MZP-t"};